import { FC } from 'react';
import type { DashboardPreset, IndicatorSelectHandler } from '@/entities/dashboards';
import type { QualityZoneRanges } from '@/shared/lib';
import { useCustomChartBindings } from '../../model/useCustomChartBindings';
import { CHART_CARD_CLASS, CHART_GRID_CLASS, chartCellClass, chartCellStyle } from './chartLayout';
import { CustomChartCard, type CustomChartPanelFilters } from './CustomChartCard';

type Props = {
  preset: DashboardPreset;
  /** Фильтры панели страницы — общие для всех диаграмм пресета */
  filters: CustomChartPanelFilters;
  /** Пороги зон качества пользователя: по ним окрашиваются элементы со своим потолком */
  zoneRanges: QualityZoneRanges;
  onSelect: IndicatorSelectHandler;
  onOpenConversation: (conversationId: number, openInNewTab: boolean) => void;
};

/**
 * Сетка диаграмм применённого дашборда-пресета: порядок задан составом пресета,
 * ширина и высота каждой диаграммы — её размером, а начало строки — её признаком.
 *
 * Разрезы и разбор выбранного считаются по всему составу сразу: разрез общий для диаграмм одного
 * имени, а связанная диаграмма ждёт выбора в своей ведущей.
 */
export const DashboardPresetGrid: FC<Props> = ({ preset, filters, zoneRanges, onSelect, onOpenConversation }) => {
  const bindings = useCustomChartBindings(preset.charts);

  return (
    <div className={CHART_GRID_CLASS}>
      {preset.charts.map((chart) => (
        <div
          key={chart.id}
          className={chartCellClass(chart.size, chart.startsRow)}
          style={chartCellStyle(chart.height)}
        >
          <div className={CHART_CARD_CLASS}>
            <CustomChartCard
              chart={chart}
              filters={filters}
              zoneRanges={zoneRanges}
              bindings={bindings.get(chart.id)}
              onSelect={onSelect}
              onOpenConversation={onOpenConversation}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
